document.querySelectorAll('.has-inline-color-cloud ul')?.forEach((ul) => {
	const li = [...ul.querySelectorAll('li')];
	if (li.length) {
		const cycle = () => {
			li.forEach((el) => el.classList.remove('active'));
			const rand = li[Math.floor(Math.random() * li.length)];
			rand.classList.add('active');
			setTimeout(() => {
				cycle();
			}, 3000);
		};
		cycle();
	}
});
